module.exports = __webpack_public_path__ + "static/media/name.b4137f0d.svg";